import React from 'react';

// Define the component props using PropTypes instead of TypeScript interface
import PropTypes from 'prop-types';

/**
 * A gradient button component styled with Tailwind CSS.
 * The gradient is achieved using a custom Tailwind class for background image.
 */
export default function GradientButton({
  title,
  onClick,
  className = '',
  textClassName = '',
  disabled = false,
  iconComponent,
}) {
  // Define a custom class for the linear gradient.
  // In a real project, this should be added to your tailwind.config.js
  // under the 'backgroundImage' section, e.g., 'bg-gradient-blue': 'linear-gradient(to right, #245EFF, #1FCDFF)'
  const gradientClassName = 'bg-gradient-to-r from-[#245EFF] to-[#1FCDFF]';

  // Disabled styling
  const disabledClasses = disabled
    ? 'opacity-60 cursor-not-allowed'
    : 'hover:opacity-90 active:opacity-80 transition duration-150 ease-in-out';

  return (
    <button
      onClick={onClick}
      disabled={disabled}
      className={`
        rounded-xl overflow-hidden shadow-lg 
        transform transition duration-150 ease-in-out 
        ${gradientClassName} 
        ${disabledClasses} 
        ${className} 
        focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-opacity-50
      `}
      // The button itself acts as the gradient container
    >
      <div
        className={`
          flex items-center justify-center 
          py-3 px-8 min-h-12
        `}
      >
        {/* Icon Component */}
        {iconComponent && (
          <div className="mr-2 flex items-center">
            {iconComponent}
          </div>
        )}

        {/* Text Title */}
        <span
          className={`
            text-white text-base font-bold text-center 
            ${textClassName}
          `}
        >
          {title}
        </span>
      </div>
    </button>
  );
}

GradientButton.propTypes = {
  title: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  className: PropTypes.string,
  textClassName: PropTypes.string,
  disabled: PropTypes.bool,
  iconComponent: PropTypes.node,
};